import React, { useState } from "react";
import { Route as RouteIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import { PageHeader } from "../../components/ui/PageHeader";
import { cn } from "../../utils/cn";

import Operation from "./operation";
import RoutesList from "./routesList";

const WeeklyToggle = ({ weekly, setWeekly }) => {
  const { t } = useTranslation();
  const base =
    "h-9 px-4 text-sm font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500";
  return (
    <div
      role="group"
      className="inline-flex overflow-hidden rounded-lg border border-border bg-bg"
    >
      <button
        type="button"
        onClick={() => setWeekly(true)}
        aria-pressed={weekly}
        className={cn(
          base,
          weekly ? "bg-brand-500 text-white" : "text-fg hover:bg-bg-muted"
        )}
      >
        {t("Lunes a viernes")}
      </button>
      <button
        type="button"
        onClick={() => setWeekly(false)}
        aria-pressed={!weekly}
        className={cn(
          base,
          "border-l border-border",
          !weekly ? "bg-brand-500 text-white" : "text-fg hover:bg-bg-muted"
        )}
      >
        {t("Sábado")}
      </button>
    </div>
  );
};

export default function Routes() {
  const { t } = useTranslation();
  const [weekly, setWeekly] = useState(true);
  return (
    <div className="w-full min-w-0 space-y-4 py-2">
      <PageHeader
        icon={<RouteIcon className="w-6 h-6 text-fg-muted" />}
        title={t("Administrar retiros")}
        subtitle={t("Planificación y asignación de rutas de retiro.")}
        actions={<WeeklyToggle weekly={weekly} setWeekly={setWeekly} />}
      />
      <Operation />
      <RoutesList />
    </div>
  );
}
